/**
 * Component to display a base64-encoded image with optional transformations.
 *
 * @component
  * @memberof Components
 * @param {Object} props - The component props.
 * @param {string} props.data - The base64-encoded image string.
 * @param {number|string} [props.width] - The width of the image (can be a number or a CSS string, e.g., "100px").
 * @param {number|string} [props.height] - The height of the image (can be a number or a CSS string, e.g., "100px").
 * @param {number} [props.rotationAngle=0] - The rotation angle in degrees.
 * @param {number} [props.zoomLevel=1] - The scale factor for zooming the image.
 * @returns {JSX.Element} The rendered base64 image component.
 */

const Base64Image = ({ data, width, height, rotationAngle = 0, zoomLevel = 1 }) => {
    return (
        <img
            src={data}
            alt="Base64 Image"
            width={width}
            height={height}
            style={{
                padding: '5px',
                transform: `rotate(${rotationAngle}deg) scale(${zoomLevel})`,
                transformOrigin: 'left',
            }} />
    )
}

export default Base64Image